module.exports = __webpack_public_path__ + "static/img/cpfw-ptzs2.8c9f4f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cpfw-ptzs2.png
// module id = 4oJb
// module chunks = 0